import { render, staticRenderFns } from "./GameSort.vue?vue&type=template&id=4bad6d7c&scoped=true"
import script from "./GameSort.vue?vue&type=script&lang=js"
export * from "./GameSort.vue?vue&type=script&lang=js"
import style0 from "./GameSort.vue?vue&type=style&index=0&id=4bad6d7c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad6d7c",
  null
  
)

export default component.exports